import { createHashRouter, Navigate } from 'react-router-dom';
import AdminRoutes from './AdminRoutes';
import AuthRoutes from './AuthRoutes';
import AdminLayouts from '../../Screens/AdminLayouts';
import AuthWrapper from '../../Screens/AuthLayouts/AuthWrapper';
import { useEffect } from 'react';
import { ResetPassword } from '../../Screens/AuthLayouts/ForgotPassword';
import { RouteErrorFallback } from '../../Components/ErrorBoundary';

const GenerateRoutes = (isAuthenticated: boolean) => {
  return [
    // Always-available public route for password reset
    {
      path: 'reset-password',
      element: <ResetPassword />,
      errorElement: <RouteErrorFallback />,
    },
    // Root route switches between Admin and Auth child sets
    {
      path: '',
      element: isAuthenticated ? <AdminLayouts /> : <AuthWrapper isAuthenticated={isAuthenticated} />,
      errorElement: <RouteErrorFallback />,
      children: isAuthenticated ? AdminRoutes.children : AuthRoutes.children,
    },
  ]
};

// Create the router object dynamically
export const createAppRouter = (isAuthenticated:boolean) => {
  return createHashRouter(GenerateRoutes(isAuthenticated), { basename: process.env.REACT_APP_BASE_NAME });
};